import { render, staticRenderFns } from "./HeaderModule.vue?vue&type=template&id=47fba6d3"
import script from "./HeaderModule.vue?vue&type=script&lang=js"
export * from "./HeaderModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./HeaderModule.vue?vue&type=style&index=0&id=47fba6d3&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports